// 页面路径 -> 菜单信息的映射
export const pageToMenuMap = {
  // Insurance 相关
  '/AccountPayable/InsuranceEnterPaymentPage': {
    key: 'InsuranceSummary',
    parentKey: 'AccountPayable',
    label: 'Insurance'
  },
  '/AccountPayable/InsuranceEditPolicyPage': {
    key: 'InsuranceSummary',
    parentKey: 'AccountPayable',
    label: 'Insurance'
  },
  '/AccountPayable/InsurancePage': {
    key: 'InsuranceSummary',
    parentKey: 'AccountPayable',
    label: 'Insurance'
  },
    '/AccountPayable/ApprovalSummary': {
    key: 'ApprovalSummary',
    parentKey: 'AccountPayable',
    label: 'Approval Summary'
  },
  '/AccountPayable/CheckApproval': {
    key: 'CheckApproval',
    parentKey: 'AccountPayable',
    label: 'Check Approval'
  },

};

// CheckApproval 和 ApprovalSummary 的页面路径配置（只需要 key，label 从 localStorage 来）
const approvalPages = [
  '/AccountPayable/ApprovalSummaryMonthlyTableDetail',
  '/AccountPayable/ApprovalSummaryUtilTableDetail',
  '/AccountPayable/ApprovalSummaryPendingTableDetail',
  '/AccountPayable/MaintenanceContractorTableDetail',
  '/AccountPayable/GardenerAPTableDetail',
  '/AccountPayable/MajorProjectTableDetail',
  '/AccountPayable/MaintenanceMonthlyWorkerDetail',
  '/AccountPayable/MaintenanceMonthlyWorkerSubDetail',
  '/AccountPayable/BusinessLicenseTableDetail',
  '/AccountPayable/MaterialListAPDetail',
  '/AccountPayable/InsuranceDetail',
];

const checkApprovalPages = [
  '/AccountPayable/CheckApprovalDetail',
  '/AccountPayable/CheckApprovalUtilPaymentDetail',
  '/AccountPayable/CheckApprovalMaintenanceDetail',
  '/AccountPayable/CheckApprovalMainContractorDetail',
  '/AccountPayable/CAGardenerAPDetail',
  '/AccountPayable/CAMonthlyWorkerDetail',
  '/AccountPayable/CAMonthlyWorkerSubDetail',
  '/AccountPayable/CABusinessLicenseDetail',
  '/AccountPayable/CAMaterialListAPDetail',
  '/AccountPayable/CheckMajorProjectTableDetail',
  '/AccountPayable/CAInsuranceDetail',
];

// 批量添加 ApprovalSummary 配置
approvalPages.forEach(path => {
  pageToMenuMap[path] = {
    key: 'ApprovalSummary',
    parentKey: 'AccountPayable',
    label: 'Approval Summary',
    useLocalStorage: true  // 标记使用 localStorage
  };
});

// 批量添加 CheckApproval 配置
checkApprovalPages.forEach(path => {
  pageToMenuMap[path] = {
    key: 'CheckApproval',
    parentKey: 'AccountPayable',
    label: 'Check Approval',
    useLocalStorage: true
  };
});

// 生成路径别名映射表
export const getPathAliasMap = () => {
  const aliasMap = {};
  Object.keys(pageToMenuMap).forEach(path => {
    aliasMap[path] = pageToMenuMap[path].key;
  });
  return aliasMap;
};

// 根据路径获取菜单信息
export const getMenuInfoByPath = (pathname, searchParams = null) => {
  const url = pathname.split('?')[0];
  const config = pageToMenuMap[url];
  
  if (!config) return null;
  
  // 如果需要从 localStorage 读取，返回基础配置（实际 label 会在 useAutoMenuHighlight 中覆盖）
  return {
    key: config.key,
    parentKey: config.parentKey,
    label: config.label,
    useLocalStorage: config.useLocalStorage
  };
};